<script setup lang="ts">
import { ref,reactive,watch,onMounted,onBeforeUnmount, computed } from 'vue'
import CustomList from "../../../compositions/CustomList.vue";
import ModalDialog from "../../../compositions/ModalDialog.vue";
import SearchBox from "../../../compositions/SearchBox.vue";
import TextBox from "../../../compositions/TextBox.vue";
import SelectBox from "../../../compositions/SelectBox.vue";
import CheckBox from "../../../compositions/CheckBox.vue";
import CsvLoader from "../../../compositions/CsvLoader.vue";
import config from "../../../config.js";
import { errorAlert,confirmAlert,successAlert } from "../../../plugins/alert";
import { getFieldValue,configKeyFromValue,postForm,deepCopy } from "../../../plugins/utility";
import { useEstimateStore } from '../../../stores/estimate';
import { useHeadEstimateStore } from '../../../stores/head_estimate';
import { getHeadMedicineMark } from "../../../plugins/pharmacy";
import qs from 'qs';
import axios from '../../../plugins/axios.ts';
import HelpAction from '../../../compositions/HelpAction.vue';

const props = defineProps({
    apis:{
      type:Object,
      required:true,
    },
    wholesalers:{
      type:Array,
      required:true,
    },
    isHead:{
      type:Boolean,
      default: () => {
        return false;
      },
    },
})
const estimate = (props.isHead ? useHeadEstimateStore() : useEstimateStore());

const listRef = ref();
const headerRef = ref();
const listHeight = ref(72);
const searchDateFrom = ref('');
const onChangeSearchDateFrom = (value) => {
  searchDateFrom.value = value;
  listSearch();
}
const searchDateTo = ref('');
const onChangeSearchDateTo = (value) => {
  searchDateTo.value = value;
  listSearch();
}
const clearDate = () => {
  searchDateFrom.value = '';
  searchDateTo.value = '';
  listSearch();
}
const changeListHeight = () => {
  if (typeof headerRef.value !== 'undefined') {
    listHeight.value = window.innerHeight - document.getElementById('header').clientHeight - document.getElementById('footer').clientHeight - headerRef.value.clientHeight - 5;
    if (typeof submitRef.value !== 'undefined' && isEdited.value) {
      listHeight.value -= (submitRef.value.clientHeight - document.getElementById('footer').clientHeight - 5);
    }
    if (listHeight.value < 200) {
      listHeight.value = 200;
    }
  }
}
const searchMedicineName = ref('');
const onChangeSearchMedicineName = (value) => {
  searchMedicineName.value = value;
}
const onKeyEnterSearchMedicineName = (value) => {
  searchMedicineName.value = value;
  listSearch();
}
const isLoadingDialog = ref(false);
const fields = reactive([
  {field_name: '採用品名', field_key: 'product_detail_name', width: '30%', align: 'text-left', sorted: false},
  {field_name: '取引卸', field_key: 'current_wholesaler_name', width: '10%', align: 'text-left', sorted: false},
  {field_name: '薬品タイプ', field_key: 'medicine_type', width: '10%', align: 'text-center', sorted:true},
  {field_name: '使用区分コード', field_key: 'use_category_code', width: '10%', align: 'text-center', sorted:true},
  {field_name: '経過措置', field_key: 'transitional_measure_date', width: '10%', align: 'text-center', sorted:true},
  {field_name: '包装薬価', field_key: 'current_package_price', width: '10%', align: 'text-center', sorted: true},
  {field_name: '購入数量', field_key: 'transaction_number', width: '10%', align: 'text-center', sorted: true},
  {field_name: '取引金額', field_key: 'transaction_amount', width: '10%', align: 'text-center', sorted: true},
]);
const optionFields = reactive({
  'is_oral' : null,
  'is_external' : null,
  'is_otc':null,
  'is_head':(props.isHead ? 1 : null),
  'is_head_estimate':(props.isHead ? 1 : null),
  'search_date_from': '',
  'search_date_to':'',
  'search_word':'',
  'page_size' : 30,
});
const listSearch = () => {
  optionFields.search_word = (searchMedicineName.value ? searchMedicineName.value : null);
  optionFields.search_date_from = searchDateFrom.value;
  optionFields.search_date_to = searchDateTo.value;
  listRef.value.resetItem();
}
const handler = (name:string,value:Object,eof:Boolean=false) => {
  if (name == 'item') {
  }
}
onBeforeUnmount(() => {
  window.removeEventListener('resize', changeListHeight);
});
onMounted(() => {
  window.addEventListener('resize', changeListHeight);
  setTimeout(changeListHeight,100);
});
//////// 見積もり出力
const isEdited = ref((estimate.estimate_list.length > 0 ? true : false));
const onChangeIsEdited = (value) => {
  isEdited.value = value;
}
const listWholesalerRef = ref();
const onChangeOutputList = (values) => {
  estimate.estimate_list.splice(0);
  for (let i=0;i<values.length;i++) {
    estimate.estimate_list.push(values[i]);
  }
}
const cancelOutput = async () => {
  let result = await confirmAlert('選択リストをリセットしますか？');
  if (result.isConfirmed) {
    estimate.estimate_list.splice(0);
    isEdited.value = false;
  }
}
const downloadOutput = async (wholesalerId) => {
  let params = {
    wholesaler_id:wholesalerId,
    pharmacy_medicine_ids:estimate.estimate_list,
    search_date_from:searchDateFrom.value,
    search_date_to:searchDateTo.value,
    is_head:(props.isHead ? 1 : null),
    is_head_estimate:(props.isHead ? 1 : null),
  }
  postForm(props.apis.estimate_download,params)
}
const submitRef = ref();
const isEstimateOutputDialog = ref(false);
const isEstimateOutputDialogLoading = ref(false);
const showEstimateOutputDialog = () => {
  isEstimateOutputDialog.value = true;
}
const closeEstimateOutputDialog = () => {
  isEstimateOutputDialog.value = false;
}
///////////////////
//////// 見積もり取込
const vitalWaitMedicineList = reactive([]);
const getVitalWaitMedicineList = async () => {
  vitalWaitMedicineList.splice(0);
  isLoadingDialog.value = true;
  try {
    let params = {page_size:10000};
    const paramsSerializer = (params) => qs.stringify(params);
    const response = await axios.get(props.apis.vital_wait_medicine_list,{params:params,paramsSerializer});
    for (let i=0;i<response.data.list.length;i++) {
      vitalWaitMedicineList.push(response.data.list[i]);
    }
  } finally {
    isLoadingDialog.value = false;
  }
}
const getVitalWaitMedicineFlg = (janCode) => {
  let result = false;
  for (let i=0;i<vitalWaitMedicineList.length;i++) {
    if (vitalWaitMedicineList[i].jan_code == janCode) {
      result = true;
      break;
    }
  }
  return result;
}
const isFileOral = ref(false);
const onChangeIsFileOral = (value) => {
  isFileOral.value = value;
  if (value) {
    isFileExternal.value = false;
    isFileOtc.value = false;
  }
  listFileSearch();
}
const isFileExternal = ref(false);
const onChangeIsFileExternal = (value) => {
  isFileExternal.value = value;
  if (value) {
    isFileOral.value = false;
    isFileOtc.value = false;
  }
  listFileSearch();
}
const isFileOtc = ref(false);
const onChangeIsFileOtc = (value) => {
  isFileOtc.value = value;
  if (value) {
    isFileOral.value = false;
    isFileExternal.value = false;
  }
  listFileSearch();
}
const isMedicineHead = ref(false);
const onChangeMedicineHead = (value) => {
  isMedicineHead.value = value;
  listFileSearch();
}
const isVitalWait = ref(false);
const onChangeVitalWait = (value) => {
  isVitalWait.value = value;
  listFileSearch();
}
const onChangeLocked = (janCode,isLocked) => {
  let index = searchUploadData(janCode);
  if (index != -1) {
    estimate.select_list[index].is_locked = isLocked;
  }
}
const onChangeAllLocked = (isLocked) => {
  isEstimateInputDialogLoading.value = true;
  try {
    let select_list = getUploadList();
    for (let i=0;i<select_list.length;i++) {
      let index = searchUploadData(select_list[i].jan_code);
      if (index != -1) {
        estimate.select_list[index].is_locked = isLocked;
      }
    }
  } finally {
    isEstimateInputDialogLoading.value = false;
  }
}
const selectSellerName = ref('全て');
const onChangeSelectSellerName = (value) => {
  selectSellerName.value = value;
  listFileSearch();
}
const listFileSearch = () => {
  //
}
const uploadFile = ref(new Object());
const getHeaderIndex = (key) => {
  return config.ESTIMATE_CSV_HEADER[key];
}
const getWholesalerIndex = (wholesalerId) => {
  let index = -1;
  for (let i=0;i<estimate.select_wholesaler_ids.length;i++) {
    if (estimate.select_wholesaler_ids[i] == Number(wholesalerId)) {
      index = i;
      break;
    }
  }
  return index;
}
const getEstimateDataIndexByJanCode = (janCode) => {
  let index = -1;
  for (let i=0;i<estimate.select_list.length;i++) {
    if (estimate.select_list[i].jan_code == janCode) {
      index = i;
      break;
    }
  }
  return index;
}
const uploadWholesalerAllCheck = (wholesalerId) => {
  let estimateList = getUploadList();
  for (let i=0;i<estimateList.length;i++) {
    if (estimateList[i].is_locked) {
      continue;
    }
    let index = getEstimateDataIndexByJanCode(estimateList[i].jan_code);
    if (index != -1) {
      estimate.select_list[index].wholesaler_id = wholesalerId;
    }
  }
}
const uploadFilehandler = (value:Object) => {
  uploadFile.value = value;
}
const uploadStart = () => {
  isEstimateInputDialogLoading.value = true;
}
const searchUploadData = (janCode) => {
  let result = -1;
  for (let j=0;j<estimate.select_list.length;j++) {
    if (estimate.select_list[j].jan_code == janCode) {
      result = j;
    }
  }
  return result;
}
const uploadComplete = (data) => {
  if (data.length <= 1) {
    errorAlert('データが空です。');
    return;
  }
  for (let i=1;i<data.length;i++) {
    if (data[i][0] == '') {
      continue;
    }
    let janCode = data[i][getHeaderIndex('JANコード')].trim()
    let recordIndex = searchUploadData(janCode);
    if (estimate.select_wholesaler_ids.indexOf(Number(data[i][getHeaderIndex('システムＩＤ１')])) == -1) {
      estimate.select_wholesaler_ids.push(Number(data[i][getHeaderIndex('システムＩＤ１')]));
    }
    let record = {
      jan_code:janCode,
      product_detail_name:data[i][getHeaderIndex('採用品名')],
      medicine_type:Number(data[i][getHeaderIndex('薬品タイプ')]),
      use_category_code:Number(data[i][getHeaderIndex('使用区分コード')]),
      seller_name:data[i][getHeaderIndex('販売元')],
      current_wholesaler_name:getPharmacyWholesalerName(Number(data[i][getHeaderIndex('システムＩＤ２')])),
      wholesaler_id:0,
      current_wholesaler_id:getWholesalerIdFromPharmacyWholesalerId(Number(data[i][getHeaderIndex('システムＩＤ２')])),
      min_wholesaler_index:-1,
      is_locked:false,
      package_unit:'',
      is_head_managed:(data[i].length > getHeaderIndex('システムＩＤ３') ? Number(data[i][getHeaderIndex('システムＩＤ３')]) : 0),
    };
    let price = (data[i][getHeaderIndex('卸単価')] ? parseFloat(data[i][getHeaderIndex('卸単価')]) : '');
    //　薬価が0ではない場合は薬価からの割引率の％、薬価が0の場合は％出せないので円表記する
    if (parseFloat(data[i][getHeaderIndex('薬価')]) > 0) {
      record.package_unit = '%';
      if (price != '') {
        //比較パーセントは小数点第二位まで使う
        price = 100 - (Math.round((parseFloat(price) / parseFloat(data[i][getHeaderIndex('薬価')])) * 100 * 100) / 100);
      }
    } else {
      record.package_unit = '円';
      if (price != '') {
        price = parseFloat(price);
      }
    }
    if (recordIndex == -1) {
      for (let j=0;j<estimate.select_wholesaler_ids.length;j++) {
        record['wholesaler_price' + String(j)] = '';
      }
      record['wholesaler_price' + String(getWholesalerIndex(data[i][getHeaderIndex('システムＩＤ１')]))] = price;
      record.wholesaler_id = Number(data[i][getHeaderIndex('システムＩＤ１')]);
      record.min_wholesaler_index = getWholesalerIndex(Number(data[i][getHeaderIndex('システムＩＤ１')]));
      estimate.select_list.push(record);
    } else {
      record = deepCopy(estimate.select_list[recordIndex]);
      record['wholesaler_price' + String(getWholesalerIndex(data[i][getHeaderIndex('システムＩＤ１')]))] = price;
      // %の場合は割引率なので一番高いもの、円の場合は値段なので一番安いものを選択する
      if (record.package_unit == '円') {
        let min = 1000000000000;
        for (let j=0;j<estimate.select_wholesaler_ids.length;j++) {
          if (record['wholesaler_price' + String(j)] == '') {
            continue;
          }
          if (min > record['wholesaler_price' + String(j)]) {
            record.wholesaler_id = Number(estimate.select_wholesaler_ids[j]);
            record.min_wholesaler_index = j;
            min = record['wholesaler_price' + String(j)];
          } else if (min == record['wholesaler_price' + String(j)] && Number(estimate.select_wholesaler_ids[j]) == record['current_wholesaler_id']) {
            //値段が同じ場合は現取引先を優先する
            record.wholesaler_id = Number(estimate.select_wholesaler_ids[j]);
            record.min_wholesaler_index = j;
            min = record['wholesaler_price' + String(j)];
          }
        }
      } else {
        let max = 0;
        for (let j=0;j<estimate.select_wholesaler_ids.length;j++) {
          if (record['wholesaler_price' + String(j)] == '') {
            continue;
          }
          if (max < record['wholesaler_price' + String(j)]) {
            record.wholesaler_id = Number(estimate.select_wholesaler_ids[j]);
            record.min_wholesaler_index = j;
            max = record['wholesaler_price' + String(j)];
          } else if (max == record['wholesaler_price' + String(j)] && Number(estimate.select_wholesaler_ids[j]) == record['current_wholesaler_id']) {
            //同じ場合は現取引先を優先する
            record.wholesaler_id = Number(estimate.select_wholesaler_ids[j]);
            record.min_wholesaler_index = j;
            max = record['wholesaler_price' + String(j)];
          }
        }
      }
      estimate.select_list[recordIndex] = record;
    }
  }
  isEstimateInputDialogLoading.value = false;
}
const updateEstimate = async () => {
  if (estimate.select_list.length == 0) {
    errorAlert('対象の採用品がありません。');
    return;
  }
  isEstimateInputDialogLoading.value = true;
  let params = {
    'select_list':[],
    'is_head':(props.isHead ? 1 : null),
    'is_head_estimate':(props.isHead ? 1 : null),
  };
  for (let i=0;i<estimate.select_list.length;i++) {
    params.select_list.push({
      jan_code:estimate.select_list[i].jan_code,
      wholesaler_id:estimate.select_list[i].wholesaler_id,
    });
  }
  try {
    const response = await axios(props.apis.estimate_update,{method:"post",data:params});
    if (response.data.status == 200) {
      successAlert('予約しました。しばらくお待ちください。');
      estimate.reset_data();
      closeEstimateInputDialog();
    }
  } finally {
    isEstimateInputDialogLoading.value = false;
  }

}
const isEstimateInputDialog = ref(false);
const isEstimateInputDialogLoading = ref(false);
const showEstimateInputDialog = async () => {
  isEstimateInputDialog.value = true;
  await getVitalWaitMedicineList();
}
const closeEstimateInputDialog = async () => {
  if (estimate.select_list.length > 0) {
    let result = await confirmAlert('編集中のデータを残しますか？');
    if (result.isConfirmed == false) {
      estimate.reset_select_data();
    }
  }
  isEstimateInputDialog.value = false;
}
const getWholesalerName = (wholesalerId,isCommon=false) => {
  let result = '';
  for (let i=0;i<props.wholesalers.length;i++) {
    if (props.wholesalers[i].id == wholesalerId) {
      if (isCommon) {
        result = props.wholesalers[i].wholesaler_common_name;
      } else {
        result = props.wholesalers[i].wholesaler_name;
      }
      break;
    }
  }
  return result;
}
const getWholesalerIdFromPharmacyWholesalerId = (pharmacyWholesalerId) => {
  let result = '';
  for (let i=0;i<props.wholesalers.length;i++) {
    if (props.wholesalers[i].pharmacy_wholesaler_id == pharmacyWholesalerId) {
      result = props.wholesalers[i].id;
      break;
    }
  }
  return result;
}
const getPharmacyWholesalerName = (pharmacyWholesalerId,isCommon=false) => {
  let result = '';
  for (let i=0;i<props.wholesalers.length;i++) {
    if (props.wholesalers[i].pharmacy_wholesaler_id == pharmacyWholesalerId) {
      if (isCommon) {
        result = props.wholesalers[i].wholesaler_common_name;
      } else {
        result = props.wholesalers[i].wholesaler_name;
      }
      break;
    }
  }
  return result;
}
const wholesalerName = computed(() => {
  return (wholesalerId,isCommon=false) => {
    return getWholesalerName(wholesalerId,isCommon);
  }
})
const sellerList = computed(() => {
  let result = [{id:'全て',name:'全て'}];
  for (let i=0;i<estimate.select_list.length;i++) {
    let exists = false;
    for (let j=0;j<result.length;j++) {
      if (result[j].id == estimate.select_list[i].seller_name) {
        exists = true;
        break;
      }
    }
    if (exists == false) {
      result.push({
        id:estimate.select_list[i].seller_name,
        name:estimate.select_list[i].seller_name,
      });
    }
  }
  return result;
})
const uploadFields = computed(() => {
  return (data) => {
    let result = {};
    let except_fields = ['wholesaler_id','min_wholesaler_index','package_unit','current_wholesaler_id','is_head_managed']
    for (let key in data) {
      if (except_fields.includes(key)) {
        continue;
      }
      result[key] = data[key];
    }
    return result;
  }
})
const getUploadList = () => {
  let result = [];
  for (let i=0;i<estimate.select_list.length;i++) {
    if (isFileOral.value) {
      if (estimate.select_list[i].use_category_code != config.USE_CATEGORY_CODES['内用薬']) {
        continue;
      }
    }
    if (isFileExternal.value) {
      if (estimate.select_list[i].use_category_code != config.USE_CATEGORY_CODES['外用薬']) {
        continue;
      }
    }
    if (isFileOtc.value) {
      if (estimate.select_list[i].medicine_type != config.MEDICINE_TYPES['OTC・雑貨']) {
        continue;
      }
    }
    if (selectSellerName.value != '全て') {
      if (estimate.select_list[i].seller_name != selectSellerName.value) {
        continue;
      }
    }
    if (isMedicineHead.value) {
      if (estimate.select_list[i].is_head_managed == 0) {
        continue;
      }
    }
    if (isVitalWait.value) {
      if (getVitalWaitMedicineFlg(estimate.select_list[i].jan_code) == false) {
        continue;
      }
    }
    result.push(estimate.select_list[i]);
  }
  return result;
}
const uploadList = computed(() => {
  return getUploadList();
})
const vitalWaitFlg = computed(() => {
  return (janCode) => {
    return getVitalWaitMedicineFlg(janCode);
  }
})
///////////////////
</script>

<style scoped>
input[type="radio"]:disabled {
  color: #817f7f;
  background-color: #817f7f;
  cursor: not-allowed; /* カーソルを禁止マークにする */
}
.table-wrap {
  overflow-x: scroll;
  height:50vh;
}
table.result-table {
  width:100%;
  overflow-y: auto;
  border-collapse:collapse;
  table-layout: fixed;
}
table.result-table > thead > tr > th {
  border-bottom: 2px solid #ccc;
  border-right: 1px solid #fff;
  position:sticky;
  top:0;
  left:0;
  z-index:1;
  background-color: rgb(97, 97, 97);
  color:#fff;
  line-height: 1.4;
}
table.result-table > tbody > tr {
  border-bottom:1px solid #ccc;
}
table.result-table > tbody > tr > td {
  padding:0.5em;
  white-space: pre-wrap;
  border: 1px solid #ccc;
}
table.result-table > thead > tr > th:nth-child(1),table.result-table > tbody > tr > td:nth-child(1) {
  width: 140px;
}
table.result-table > thead > tr > th:nth-child(2),table.result-table > tbody > tr > td:nth-child(2) {
  width: 350px;
}
table.result-table > thead > tr > th:nth-child(3),table.result-table > tbody > tr > td:nth-child(3) {
  width: 120px;
}
table.result-table > thead > tr > th:nth-child(4),table.result-table > tbody > tr > td:nth-child(4) {
  width: 120px;
}
table.result-table > thead > tr > th:nth-child(5),table.result-table > tbody > tr > td:nth-child(5) {
  width: 180px;
}
table.result-table > thead > tr > th:nth-child(6),table.result-table > tbody > tr > td:nth-child(6) {
  width: 120px;
}
table.result-table > thead > tr > th:nth-child(7),table.result-table > tbody > tr > td:nth-child(7) {
  width: 60px;
}
/* ここから卸列 */
table.result-table > thead > tr > th:nth-child(8),table.result-table > tbody > tr > td:nth-child(8) {
  width: 100px;
}
table.result-table > thead > tr > th:nth-child(9),table.result-table > tbody > tr > td:nth-child(9) {
  width: 100px;
}
table.result-table > thead > tr > th:nth-child(10),table.result-table > tbody > tr > td:nth-child(10) {
  width: 100px;
}
table.result-table > thead > tr > th:nth-child(11),table.result-table > tbody > tr > td:nth-child(11) {
  width: 100px;
}
table.result-table > thead > tr > th:nth-child(12),table.result-table > tbody > tr > td:nth-child(12) {
  width: 100px;
}
table.result-table > thead > tr > th:nth-child(13),table.result-table > tbody > tr > td:nth-child(13) {
  width: 100px;
}
table.result-table > thead > tr > th:nth-child(14),table.result-table > tbody > tr > td:nth-child(14) {
  width: 100px;
}
table.result-table > thead > tr > th:nth-child(15),table.result-table > tbody > tr > td:nth-child(15) {
  width: 100px;
}
table.result-table > thead > tr > th:nth-child(15),table.result-table > tbody > tr > td:nth-child(16) {
  width: 100px;
}
table.result-table > thead > tr > th:nth-child(15),table.result-table > tbody > tr > td:nth-child(17) {
  width: 100px;
}
table.result-table > thead > tr > th:nth-child(15),table.result-table > tbody > tr > td:nth-child(18) {
  width: 100px;
}
table.result-table > thead > tr > th:nth-child(15),table.result-table > tbody > tr > td:nth-child(19) {
  width: 100px;
}
table.result-table > thead > tr > th:nth-child(15),table.result-table > tbody > tr > td:nth-child(20) {
  width: 100px;
}
</style>
<template>
<div ref="element" class="relative">
  <div ref="headerRef" class="w-full flex items-center justify-between p-2 bg-gray-100 rounded">
    <div>
      <div class="m-1">
        <a href="javascript:void(0)" @click="onChangeIsEdited(true)" class="text-black bg-amber-300 hover:bg-amber-400 focus:ring-4 focus:ring-amber-200 block font-medium rounded-lg text-xs md:text-base px-4 py-1 w-full sm:w-auto text-center ml-2">見積り出力選択</a>
      </div>
    </div>
    <div class="flex items-center justify-end">
      <div class="m-1 flex flex-row items-center">
        <div class="mr-1">取引期間:</div>
        <div class="mr-1">
            <text-box
                :value="searchDateFrom"
                type="date"
                :on-change="onChangeSearchDateFrom"
                place-holder="日付を入力"
            ></text-box>
        </div>
        <div class="tex-lg mr-1">~</div>
        <div class="mr-1">
            <text-box
                :value="searchDateTo"
                type="date"
                :on-change="onChangeSearchDateTo"
                place-holder="日付を入力"
            ></text-box>
        </div>
        <div>
            <a @click="clearDate" class="block cursor-pointer m-1 text-lg text-red-500"><i class="fa-solid fa-calendar-xmark"></i></a>
        </div>
      </div>
      <div class="m-1">
        <search-box
          :search-word="searchMedicineName"
          :on-change="onChangeSearchMedicineName"
          :on-enter="onKeyEnterSearchMedicineName"
          place-holder="採用品名を入力"
        ></search-box>
      </div>
      <div class="m-1 relative">
        <span v-show="estimate.select_list.length > 0" class="inline-flex absolute -top-1 -right-1 justify-center items-center w-6 h-6 text-xs font-bold text-white bg-amber-500 rounded-full border-2 border-white dark:border-gray-900"><i class="fa-regular fa-pen-to-square"></i></span>
        <a href="javascript:void(0)" @click="showEstimateInputDialog" class="text-black bg-amber-300 hover:bg-amber-400 focus:ring-4 focus:ring-amber-200 block font-medium rounded-lg text-xs md:text-base px-4 py-1 w-full sm:w-auto text-center ml-2">見積り取込</a>
      </div>
    </div>
  </div>
  <div class="w-full">
    <custom-list
      ref="listRef"
      :table-fields="fields"
      :option-fields="optionFields"
      :api-url="apis.estimate_list"
      :height="listHeight + 'px'"
      :is-all-check="true"
      :is-checkable="isEdited"
      :check-values="estimate.estimate_list"
      :on-check-change="onChangeOutputList"
      list-key="id"
      :handler="handler"
    >
    <template v-slot:item="slotProps">
        <td v-for="(field,index) in fields" :key="index" :style="'width:' + field.width" :class="field.align">
          <div v-if="field.field_key == 'product_detail_name'" :class="field.align">
            {{ slotProps.item.product_detail_name }}<span v-html="slotProps.item.warning_mark"></span> <span v-html="slotProps.item.is_head_managed ? getHeadMedicineMark() : ''"></span>
          </div>
          <div v-else-if="field.field_key == 'medicine_type'" :class="field.align">
            {{ configKeyFromValue(config.MEDICINE_TYPES,slotProps.item.medicine_type).replace('メディコード','') }}
          </div>
          <div v-else-if="field.field_key == 'use_category_code'" :class="field.align">
            {{ configKeyFromValue(config.USE_CATEGORY_CODES,slotProps.item.use_category_code) }}
          </div>
          <div v-else-if="field.field_key == 'transaction_number'" :class="field.align">
            {{ slotProps.item.transaction_number.toLocaleString() }}
          </div>
          <div v-else-if="field.field_key == 'transaction_amount'" :class="field.align">
            &yen;{{ slotProps.item.transaction_amount.toLocaleString() }}
          </div>
          <div v-else-if="field.field_key == 'current_package_price'" :class="field.align">
            &yen;{{ slotProps.item.current_package_price.toLocaleString() }}
          </div>
          <div v-else :class="field.align">
            {{ getFieldValue(slotProps.item,field.field_key) }}
          </div>
        </td>
    </template>
    </custom-list>
  </div>
  <div ref="submitRef" v-show="isEdited" class="fixed bottom-0 right-0 w-full flex items-center justify-end flex-wrap p-2 bg-gray-100 rounded">
    <a href="javascript:void(0)" @click="cancelOutput" class="flex py-2.5 px-5 m-2 text-base font-medium text-white focus:outline-none bg-red-800 rounded-full border border-gray-200 hover:bg-red-600 hover:text-white focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">リストリセット</a>
    <button type="button" @click="showEstimateOutputDialog" class="py-2.5 px-5 m-2　text-base font-medium text-gray-900 focus:outline-none bg-white rounded-full border border-gray-200 hover:bg-amber-300 hover:text-black focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">見積り出力</button>
  </div>
</div>
<modal-dialog
  :is-visible="isEstimateOutputDialog"
  width="30%"
  :close="closeEstimateOutputDialog"
  :isLoading="isEstimateOutputDialogLoading"
>
  <template v-slot:header>
    見積りデータ出力
  </template>
  <template v-slot:default>
  <div class="mb-6">
    <div class="w-full">
      <div>出力する卸業者のリンクをクリックしてください。</div>
      <custom-list
        ref="listWholesalerRef"
        :default-values="wholesalers"
        height="40vh"
        width="100%"
        list-key="id"
      >
      <template v-slot:item="slotProps">
        <div><a href="javascript:void(0)" class="text-blue-500 underline" @click="downloadOutput(slotProps.item.id)">{{ slotProps.item.wholesaler_name }}</a></div>
      </template>
      </custom-list>
    </div>
  </div>
  </template>
</modal-dialog>

<modal-dialog
  :is-visible="isEstimateInputDialog"
  width="90%"
  :close="closeEstimateInputDialog"
  :isLoading="isEstimateInputDialogLoading"
>
  <template v-slot:header>
    見積りデータ取り込み
  </template>
  <template v-slot:default>
  <div class="mb-6">
    <table class="w-full border border-gray-300 mb-2">
      <tr class="border-b border-gray-300">
        <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">見積りファイル(CSVファイル)<br>※卸別のファイルを読み込んでください。</th>
        <td class="block py-3 text-sm md:table-cell md:w-2/3 md:px-3 md:py-2">
          <csv-loader
            :value="uploadFile"
            :handler="uploadFilehandler"
            :loadStart="uploadStart"
            :loadComplete="uploadComplete"
          ></csv-loader>
        </td>
      </tr>
      <tr class="border-b border-gray-300">
        <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">現在の取り込み済み卸業者</th>
        <td class="py-3 text-sm flex flex-wrap items-start justify-start md:w-2/3 md:px-3 md:py-2">
          <div v-for="uploadWholesalerId in estimate.select_wholesaler_ids" :key="uploadWholesalerId" class="mr-2">
            {{ wholesalerName(uploadWholesalerId) }}
          </div>
        </td>
      </tr>
    </table>
    <div class="py-2 px-8 bg-gray-100 flex flex-row items-center justify-end">
      <div class="m-1">
        <check-box
          label="出荷調整中"
          :value="isVitalWait"
          :on-change="onChangeVitalWait"
        ></check-box>
      </div>
      <div class="m-1">
        <check-box
          label="本部管理品"
          :value="isMedicineHead"
          :on-change="onChangeMedicineHead"
        ></check-box>
      </div>
      <div class="m-1">
        <select-box
          :value="selectSellerName"
          :options="sellerList"
          :on-change="onChangeSelectSellerName"
          :is-searchable="false"
          list-height="30em"
          place-holder=""
        ></select-box>
      </div>
      <div class="m-1">
        <check-box
          label="内用薬"
          :value="isFileOral"
          :on-change="onChangeIsFileOral"
        ></check-box>
      </div>
      <div class="m-1">
        <check-box
          label="外用薬"
          :value="isFileExternal"
          :on-change="onChangeIsFileExternal"
        ></check-box>
      </div>
      <div class="m-1">
        <check-box
          label="OTC・雑貨"
          :value="isFileOtc"
          :on-change="onChangeIsFileOtc"
        ></check-box>
      </div>
    </div>
    <div>卸別の数値は%の場合は薬価に対しての割引率、薬価が0で率が出せない場合は円で卸単価をそのまま表示したものとなります。</div>
    <div class="table-wrap">
      <table class="result-table">
        <thead>
          <tr>
            <th>JANコード</th>
            <th>採用品名</th>
            <th>薬品タイプ</th>
            <th>使用区分コード</th>
            <th>販売元</th>
            <th>現取引卸</th>
            <th>
              <a href="javascript:void(0)" @click="onChangeAllLocked(false)" class="cursor mr-2 text-xl"><i class="fa-solid fa-lock-open"></i></a>
              <a href="javascript:void(0)" @click="onChangeAllLocked(true)" class="cursor text-xl"><i class="fa-solid fa-lock"></i></a>
            </th>
            <th v-for="wholesalerDataId in estimate.select_wholesaler_ids" :key="wholesalerDataId">{{ wholesalerName(wholesalerDataId,true) }}<a href="javascript:void(0)" class="text-xl cursor" @click="uploadWholesalerAllCheck(wholesalerDataId)"><i class="fa-solid fa-check-double"></i></a></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="uploadFileData in uploadList" :key="uploadFileData.jan_code">
            <td v-for="(uploadFieldValue,uploadFieldKey) in uploadFields(uploadFileData)" :key="uploadFileData.jan_code + '_' + uploadFieldKey" :class="'w-full ' + (uploadFileData.min_wholesaler_index != -1 && uploadFieldKey == 'wholesaler_price' + String(uploadFileData.min_wholesaler_index) ? 'bg-yellow-300' : '')">
              <div v-if="uploadFieldKey == 'jan_code'" class="w-full text-left">
                {{ uploadFieldValue }}
              </div>
              <div v-else-if="uploadFieldKey == 'is_locked'" class="text-center">
                <a href="javascript:void(0)" @click="onChangeLocked(uploadFileData.jan_code,true)" class="cursor mr-2 text-xl" v-if="uploadFileData.is_locked == false"><i class="fa-solid fa-lock-open"></i></a>
                <a href="javascript:void(0)" @click="onChangeLocked(uploadFileData.jan_code,false)" class="cursor mr-2 text-xl" v-else><i class="fa-solid fa-lock"></i></a>
              </div>
              <div v-else-if="uploadFieldKey == 'product_detail_name'" class="text-left">
                {{ uploadFieldValue }} <span v-show="uploadFileData['is_head_managed']" v-html="uploadFileData['is_head_managed'] ? getHeadMedicineMark() : ''"></span>
                <span v-if="vitalWaitFlg(uploadFileData['jan_code'])" class="text-white bg-red-500 m-1 py-1 px-2 text-xs font-xs rounded-full border border-gray-200">出荷調整中</span>
              </div>
              <div v-else-if="uploadFieldKey == 'seller_name'" class="text-left">
                {{ uploadFieldValue }}
              </div>
              <div v-else-if="uploadFieldKey == 'current_wholesaler_name'" class="text-left">
                {{ uploadFieldValue }}
              </div>
              <div v-else-if="uploadFieldKey == 'medicine_type'" class="text-center">
                {{ configKeyFromValue(config.MEDICINE_TYPES,uploadFieldValue).replace('メディコード','') }}
              </div>
              <div v-else-if="uploadFieldKey == 'use_category_code'" class="text-center">
                {{ configKeyFromValue(config.USE_CATEGORY_CODES,uploadFieldValue) }}
              </div>
              <div v-else class="w-full flex flex-row items-center justify-center">
                <div v-if="uploadFieldValue">
                  <input type="radio" :name="'jan_code_' + uploadFileData.jan_code" :id="'jan_code_' + uploadFileData.jan_code + '_' + uploadFieldKey" :value="estimate.select_wholesaler_ids[Number(uploadFieldKey.replace('wholesaler_price',''))]" v-model="uploadFileData.wholesaler_id" v-bind:disabled="uploadFileData.is_locked">
                  <label class="pl-2 mr-2" :for="'jan_code_' + uploadFileData.jan_code + '_' + uploadFieldKey">{{ uploadFieldValue.toLocaleString() }}{{ uploadFileData.package_unit }}</label>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="flex">
    <div class="flex-row mr-2">
      <button type="button" @click="updateEstimate" class="w-full py-2.5 px-5 mr-2 my-2 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-full border border-gray-200 hover:bg-amber-300 hover:text-black focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">見積り反映する</button>
    </div>
    <div class="flex-row">
      <button type="button" @click="closeEstimateInputDialog" class="w-full py-2.5 px-5 mr-2 my-2 text-sm font-medium text-white focus:outline-none bg-red-700 rounded-full border border-gray-200 hover:bg-red-600 hover:text-white focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-red-600 dark:hover:text-white dark:hover:bg-red-700">閉じる</button>
    </div>
  </div>
  </template>
</modal-dialog>

<modal-dialog
  :is-visible="isLoadingDialog"
  width="40%"
  :isLoading="true"
>
  <template v-slot:header>
  </template>
  <template v-slot:default>
  <div class="mb-6">
    処理中です。
  </div>
  </template>
</modal-dialog>

</template>

